import { render, staticRenderFns } from "./MobOverview.vue?vue&type=template&id=2d10f96e&scoped=true"
import script from "./MobOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./MobOverview.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d10f96e",
  null
  
)

export default component.exports